<h1 mat-dialog-title>
    Edit API Settings
    <mat-icon (click)="onCancel()" style="float: right;">close</mat-icon>
</h1>

<form [formGroup]="apiForm" (ngSubmit)="onSubmit()">
    <div mat-dialog-content class="scroll-container">
        <div class="row">
            <!-- API Type Dropdown -->
            <div class="col-lg-12 col-md-12 col-sm-12">
                <mat-form-field class="mb-25">
                    <mat-label>API Type</mat-label>
                    <mat-select formControlName="api_type">
                        <mat-option [value]="1">shipearlyapp</mat-option>
                        <mat-option [value]="2">linnworks</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Fields for Type 1: shipearlyapp -->
            <ng-container *ngIf="apiForm.get('api_type')?.value === 1">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <mat-form-field class="mb-25">
                        <mat-label>Client ID</mat-label>
                        <input matInput formControlName="api_key">
                    </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <mat-form-field class="mb-25">
                        <mat-label>Client Secret</mat-label>
                        <input matInput formControlName="api_secret">
                    </mat-form-field>
                </div>
            </ng-container>

            <!-- Fields for Type 2: linnworks -->
            <ng-container *ngIf="apiForm.get('api_type')?.value === 2">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <mat-form-field class="mb-25">
                        <mat-label>Application ID</mat-label>
                        <input matInput formControlName="application_id">
                    </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <mat-form-field class="mb-25">
                        <mat-label>Application Secret</mat-label>
                        <input matInput formControlName="application_secret">
                    </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <mat-form-field class="mb-25">
                        <mat-label>Token</mat-label>
                        <input matInput formControlName="token">
                    </mat-form-field>
                </div>
            </ng-container>
        </div>
    </div>
    <div mat-dialog-actions style="justify-content: right;">
        <button mat-flat-button type="button" color="warn" (click)="onCancel()">Cancel</button>
        <button mat-flat-button type="submit" class="daxa">Update</button>
    </div>
</form>

<!-- Loader Overlay -->
<div *ngIf="loading" class="export-overlay">
    <div class="spinner"></div>
</div>